import React from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../loader-button/LoaderButton';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const ConfirmModal = ({ showAlert, setShowAlert, loader, confirmCallback, value, name }) => {
  return (
    <>
      <Modal isOpen={showAlert} toggle={() => setShowAlert(!showAlert)}>
        <ModalHeader>Delete Confirmation</ModalHeader>
        <ModalBody>
          You are about to delete{' '}
          <span className="active" data-testid={'key-name'}>
            {name}
          </span>
          , this change can not be undone.
        </ModalBody>
        <ModalFooter>
          <>
            <Button color="falcon-danger" onClick={() => setShowAlert(!showAlert)}>
              Cancel
            </Button>
            <LoaderButton
              color="falcon-primary"
              onClick={() => confirmCallback(value)}
              isLoading={loader}
              name="save-and-add"
              data-testid={'delete-key-btn'}
            >
              Delete
            </LoaderButton>
          </>
        </ModalFooter>
      </Modal>
    </>
  );
};

ConfirmModal.propTypes = {
  value: PropTypes.number,
  loader: PropTypes.bool,
  confirmCallback: PropTypes.func,
  setShowAlert: PropTypes.func,
  showAlert: PropTypes.bool,
  name: PropTypes.string
};

export default ConfirmModal;
